// extracted by mini-css-extract-plugin
export default {"root":"iconbutton_root__jMSKi","s":"iconbutton_s__pfZXq","m":"iconbutton_m__A+PtJ","l":"iconbutton_l__q7Ea2"};